import axios from 'axios';
import queryString from 'query-string';
import { OAUTH_TOKEN_HEADERS, SSO_LOGOUT_URL } from './sso.config';
import { getHeaders } from '../utils/common';
import { getUserByEmail } from './admin.service';
import { appConfig } from '../config/appConfig';
import { notification } from 'antd';

const { allRoles } = appConfig;

export const fetchTokens = async (code: string | (string | null)[]) => {
  const payload = {
    grant_type: 'authorization_code',
    client_id: import.meta.env.PA_OAUTH_CLIENT_ID,
    redirect_uri: `${window.location.origin}`,
    code
  };
  try {
    const response = await axios.post(
      `${import.meta.env.PA_CROPWISE_API_URL}/oauth/token`,
      queryString.stringify(payload),
      {
        headers: OAUTH_TOKEN_HEADERS
      }
    );
    const tokens = response.data;
    return tokens;
  } catch (e) {
    console.warn(e);
    return null;
  }
};

const apiCall = async (wId: string) => {
  const url = `${import.meta.env.PA_CROPWISE_API_URL}/v2/workspaces/${wId}`;
  const app_id = 'ffaf7978-6c37-4120-8b4f-38b714119d91';
  try {
    const response = await axios.get(url, {
      headers: { ...getHeaders() }
    });
    const res = response.data;
    const contract = res.contracts.find((item: { app_id: string }) => item.app_id === app_id);
    if (contract?.entitlements.length > 0) {
      return { isValid: true, entitlements: contract.entitlements };
    } else {
      return { isValid: true, entitlements: [] };
    }
  } catch (e) {
    console.warn(e);
    return { isValid: false, entitlements: [] };
  }
};

export const getEntitlementsDetails = () => {
  let workspaceCounter = 1;
  const EAME_ALLOWED_WORKSPACES = {
    1: '6386fa2d-2698-4e12-abc6-15bad6a17cec',
    2: '963acd31-330d-4fd2-9c5f-10e37b1c4362',
    3: '49ea8685-4102-40f1-8bcc-b6ae15827cd6'
  };

  return new Promise((resolve, rejects) => {
    const getWorkspaceContent = async () => {
      const res = await apiCall(EAME_ALLOWED_WORKSPACES[workspaceCounter]);
      if (res?.isValid && res.entitlements.length > 0) {
        resolve(res.entitlements);
      } else {
        if (workspaceCounter >= 3) {
          rejects(new Error('no pa access'));
          localStorage.setItem('rejected', localStorage.getItem('tokens'));
        } else {
          workspaceCounter++;
          await getWorkspaceContent();
        }
      }
    };
    if (localStorage.getItem('rejected') === null) {
      void getWorkspaceContent().catch(rejects);
    }
  });
};

export const fetchCurrentUserDetails = async () => {
  const authorizationAttribute = getHeaders().Authorization;
  const headers = {
    'Content-Type': 'application/json',
    authorization: authorizationAttribute,
    clientKey: import.meta.env.PA_CLIENT_KEY || ''
  };

  const res = await axios.get(`${import.meta.env.PA_API_URL}/me/NKProductAnalyzer`, {
    headers
  });

  return res.data;
};
export const logoutSSOUserFromApp = () => {
  window.location.href = SSO_LOGOUT_URL;
};

export const getCrops = (data: any[]) => {
  const userCrops = {};
  const crops = data.filter((item) => item.name === 'crop');
  crops.forEach((item) => {
    const newRegion = item.key.split(':')[0];
    const newCrop = item.key.split(':')[1].split(',');
    userCrops[newRegion] = [...newCrop];
  });
  return userCrops;
};

export const getUserSession = async () => {
  const adminRoles = allRoles;

  const authorizationAttribute = getHeaders().Authorization;
  const headers = {
    'Content-Type': 'application/json',
    authorization: authorizationAttribute
  };
  try {
    // const res = await axios.get(`${import.meta.env.PA_CROPWISE_API_URL}/v2/accounts/me`, {
    //   headers
    // });

    const url = `${import.meta.env.PA_CROPWISE_API_URL}/v2/accounts/me?attributes=licensing_accounts`;

    const res = await axios.get(url, {
      headers: headers
    });

    if (!res.data) {
      console.warn('No user session data found');
      return { userSession: null, isAdmin: false, status: res?.status };
    } else if (res.data.email) {
      const userData = await getUserByEmail(res.data.email);
      const userSession = {
        ...userData[0]
      };
      const { has_access_to_persona_mgmt, has_access_to_user_mgmt, role } = userData[0].role;

      const isAdmin =
        (adminRoles.includes(role) && has_access_to_user_mgmt) ??
        (adminRoles.includes(role) && has_access_to_persona_mgmt) ??
        false;

      return { userSession, isAdmin };
    } else {
      return { userSession: null, isAdmin: false, status: res?.status };
    }
  } catch (error) {
    console.error('Error fetching user session:', error);
    if ([401, 403].includes(error?.response?.status)) {
      notification.error({
        message: 'User session',
        description: 'The user session could not be found. Please log in again.'
      });
      // window.location.href = `https://${import.meta.env.PA_ACCOUNTS_ENDPOINT}/exit?continue=${window.location.origin}`;
      localStorage.removeItem('tokens');
      window.location.href = SSO_LOGOUT_URL;
      // window.location.href = SSO_LOGIN_URL;
      // return;
    } else {
      return { userSession: null, isAdmin: false, status: error?.status };
    }
  }
};
